import { render, staticRenderFns } from "./CaseItem.vue?vue&type=template&id=274e2218"
import script from "./CaseItem.vue?vue&type=script&lang=js"
export * from "./CaseItem.vue?vue&type=script&lang=js"
import style0 from "./CaseItem.vue?vue&type=style&index=0&id=274e2218&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports